import { ProductCardListLoader } from '../../list-loaders/product-card-list-loader/ProductCardListLoader';
import styles from './AddProductsDrawer.module.scss';

export const AddProductsDrawerLoader = () => (
  <div className={styles['add-products-drawer-loader']}>
    {[...Array(4).keys()].map((key) => (
      <ProductCardListLoader key={key} className={styles['add-products-drawer-loader-card']} forceMobileView={true} />
    ))}
  </div>
);
